import Styles from './TableBorderThicknessPicker.module.scss'
import cx from 'classnames'
import { type EditorView } from 'prosemirror-view'
import { setBorderAttr } from 'common/Prose/Commands/table/mutation'
import { Tooltip } from 'components/Tooltip/Tooltip'

const thicknessOptions = ['1px', '3px', '5px', '7px'] as const

type thickness = (typeof thicknessOptions)[number]
type Props = {
  closePicker?: () => void
  includeDropdownStyles?: boolean
  view: EditorView
  focusView?: boolean
}

export const TableBorderThicknessPicker = ({
  closePicker,
  includeDropdownStyles = true,
  view,
  focusView = true,
}: Props) => {
  const activeBorderThicknesses: thickness[] = []

  const setBorderThickness = (thickness: thickness) => {
    setBorderAttr({ thickness })(view.state, view.dispatch)
    closePicker?.()
    if (focusView) view.focus()
  }

  return (
    <div className={cx({ [Styles.dropdownContainer]: includeDropdownStyles })}>
      <div className={Styles.thicknessOptions}>
        {thicknessOptions.map((thickness) => (
          <Tooltip key={thickness} label={thickness} placement="right">
            <div
              aria-label={`Change border thickness to ${thickness}`}
              className={cx(Styles.thicknessOption, { [Styles.active]: activeBorderThicknesses.includes(thickness) })}
              onClick={() => setBorderThickness(thickness)}
              role="button"
            >
              <span style={{ borderTopWidth: thickness }}></span>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  )
}
